export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
            关于韩漫
          </h2>
          <div className="text-foreground-600 text-sm md:text-base leading-relaxed space-y-4">
            <p>
              韩漫导航平台致力于为中文韩漫爱好者提供最全面的<strong>韩漫网站</strong>聚合入口服务。
              我们精心收录<strong>韩漫网</strong>、<strong>韩漫之家</strong>、<strong>韩漫屋</strong>等热门韩漫漫画网站，
              按题材分类整理，方便漫迷快速找到心仪的<strong>免费韩漫网址</strong>在线观看。
            </p>
            <p>
              平台每日跟踪各大韩漫站点的更新动态，确保导航信息的及时性与准确性。无论您喜欢恋爱、奇幻、热血还是悬疑题材，
              都能在这里找到对应的韩漫漫画网站入口，一站式满足<strong>韩漫在线观看</strong>需求。
            </p>
            <p>
              我们的目标是成为中文互联网上最值得信赖的<strong>韩漫网址大全</strong>，
              让每一位韩漫爱好者都能轻松发现优质内容，畅享韩漫世界的精彩。
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-6 mt-8">
            <div className="text-center">
              <div className="font-heading text-xl font-bold text-primary-500">2020</div>
              <div className="text-xs text-foreground-500 mt-1">创立年份</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-xl font-bold text-accent-500">10万+</div>
              <div className="text-xs text-foreground-500 mt-1">月访问用户</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-xl font-bold text-primary-500">500+</div>
              <div className="text-xs text-foreground-500 mt-1">收录漫画</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}